import React from "react";
import { STYLES } from "@/lib/styles";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function StyleSelect({ selected, onSelect, onConfirm, onBack }) {
  return (
    <div
      className="relative min-h-screen w-full flex flex-col px-6 sm:px-10 py-8"
      data-testid="style-select-screen"
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-6 fade-up">
        <button
          onClick={onBack}
          data-testid="style-back-button"
          className="flex items-center gap-2 text-[#A1A1AA] hover:text-white transition-colors text-sm tracking-[0.2em] uppercase"
        >
          <ChevronLeft size={18} />
          Nazaj
        </button>
        <div className="text-center">
          <p className="text-[#A1A1AA] text-[10px] sm:text-xs tracking-[0.4em] uppercase">
            Korak 1 / 3
          </p>
        </div>
        <div className="w-16" />
      </div>

      {/* Title */}
      <div className="text-center mb-8 fade-up fade-up-d1">
        <h2
          className="font-display tracking-bond text-[#C9A961] text-3xl sm:text-4xl md:text-5xl uppercase"
          data-testid="style-select-title"
        >
          Izberi svojo misijo
        </h2>
        <div className="mx-auto mt-4 w-24 h-px bg-[#C9A961]/40" />
        <p className="mt-4 text-[#A1A1AA] text-sm sm:text-base">
          Izberi scenarij za svojo tajno identiteto.
        </p>
      </div>

      {/* Cards */}
      <div
        className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-6xl w-full mx-auto fade-up fade-up-d2"
        data-testid="style-grid"
      >
        {STYLES.map((s) => {
          const isSelected = selected === s.id;
          return (
            <button
              key={s.id}
              onClick={() => onSelect(s.id)}
              data-testid={`style-card-${s.id}`}
              className={`relative aspect-[9/16] rounded-lg overflow-hidden group transition-all duration-300 border ${
                isSelected
                  ? "border-[#C9A961] scale-[1.02] shadow-[0_0_40px_rgba(201,169,97,0.35)]"
                  : "border-white/10 hover:border-[#C9A961]/60"
              }`}
            >
              <img
                src={s.image}
                alt={s.title}
                className={`absolute inset-0 w-full h-full object-cover transition-transform duration-700 ${
                  isSelected ? "scale-105" : "group-hover:scale-105"
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              {isSelected && (
                <div className="absolute top-3 right-3 z-10 bg-[#C9A961] text-black w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold">
                  ✓
                </div>
              )}
              <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-5 text-left">
                <p className="font-display text-[#C9A961] text-base sm:text-xl tracking-[0.15em] uppercase">
                  {s.title}
                </p>
                <p className="text-[#A1A1AA] text-xs sm:text-sm mt-1 tracking-wider">
                  {s.subtitle}
                </p>
              </div>
            </button>
          );
        })}
      </div>

      {/* CTA */}
      <div className="mt-6 flex justify-center fade-up fade-up-d3">
        <button
          onClick={() => selected && onConfirm(selected)}
          disabled={!selected}
          data-testid="style-continue-button"
          className={`relative overflow-hidden border px-12 sm:px-20 py-5 sm:py-6 uppercase tracking-bond font-medium text-base sm:text-lg transition-all duration-300 inline-flex items-center gap-3 ${
            selected
              ? "border-[#C9A961] text-[#C9A961] hover:bg-[#C9A961]/10 active:scale-[0.98]"
              : "border-white/10 text-white/30 cursor-not-allowed"
          }`}
        >
          Nadaljuj
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
}
